/**
 * @generated SignedSource<<8f65c9d9ce43cc7bebf91d1dd793aba3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HpSharedLocationsModule_viewer$data = {
  readonly auctionsModuleFF: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationItems_viewer">;
  readonly " $fragmentType": "HpSharedLocationsModule_viewer";
};
export type HpSharedLocationsModule_viewer$key = {
  readonly " $data"?: HpSharedLocationsModule_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"HpSharedLocationsModule_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isAuctionItemsFF"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "HpSharedLocationsModule_viewer",
  "selections": [
    {
      "alias": "auctionsModuleFF",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "auctionsHomepageModule"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"auctionsHomepageModule\")"
    },
    {
      "condition": "isAuctionItemsFF",
      "kind": "Condition",
      "passingValue": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HpSharedLocationItems_viewer"
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "67335084cb5619699f3f517ea9bcb9a0";

export default node;
